import React from 'react';
import '../../css/style.scss';
import { TransactionInfoErrorBoundary } from './error/TransactionInfoErrorBoundary';

const TransactionInfoRouterView = () => {
  return (
    <TransactionInfoErrorBoundary/>
  );
};

export default TransactionInfoRouterView;
